import { useEffect, useState } from 'react';

export const Loading = ({ heading, screen }: { heading: string; screen: number }) => {
  const messageSets = [
    ['Fetching project data...', 'Crafting your build...'],
    ['Assembling UI...', 'Setting up flow...'],
  ];

  // Pick the appropriate set based on `screen`, fallback to the first set
  const texts = messageSets[screen] ?? messageSets[0];

  // State to determine which message to show
  const [currentIdx, setCurrentIdx] = useState(0);

  useEffect(() => {
    if (texts.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIdx((prevIdx) => {
        if (prevIdx + 1 < texts.length) {
          return prevIdx + 1;
        }

        clearInterval(interval);
        return prevIdx;
      });
    }, 2000);

    return () => clearInterval(interval);
  }, [texts]);

  return (
    <div
      className="fixed inset-0 bg-black flex items-center justify-center z-[9999]"
      style={{ fontFamily: 'Inter Display' }}
    >
      <div className="flex flex-col items-center gap-4">
        <p className="text-white font-medium text-3xl">{heading}</p>
        <div className="text-center w-full text-gray-400 i-svg-spinners:3-dots-fade text-4xl mt-4"></div>
        <div className="flex flex-col items-center mt-2 gap-1">
          <span className="text-white text-md" key={currentIdx}>
            {texts[currentIdx]}
          </span>
        </div>
      </div>
    </div>
  );
};
